module.exports = __webpack_public_path__ + "static/media/md-warning.2f8f481c.svg";